/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { css } from "styled-components";
import { darken } from "polished";
import Colors from "../../constants/Colors";
import { FiraSansBold } from "../Text";
import { Breakpoints } from "../../constants/Breakpoints";
import globalStyles from "globalStyles";

const primaryMixin = css`
  color: ${globalStyles.components.button2.primaryMixin.primary};
  background-color: ${globalStyles.components.button2.primaryMixin.secondary};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  margin: 0px 10px 0px 0px;

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background-color: ${darken(
      0.1,
      globalStyles.components.button2.primaryMixin.secondary
    )};
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
  }
  &:active:not(:disabled) {
    background-color: ${darken(
      0.2,
      globalStyles.components.button2.primaryMixin.secondary
    )};
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin: 0;
  }
`;

const outlinePrimaryMixin = css`
  color: ${globalStyles.components.button2.outlinePrimaryMixin.primary};
  border: 1px ${({ dashed }) => (dashed ? "dashed" : "solid")}
    ${globalStyles.components.button2.outlinePrimaryMixin.secondary};
  padding: 4px 16px;
  text-transform: none;
  ${FiraSansBold}

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: white;
    border-color: ${globalStyles.components.button2.outlinePrimaryMixin
      .secondary};
    background: ${globalStyles.components.button2.outlinePrimaryMixin
      .secondary};
  }
  &:active:not(:disabled) {
    background-color: ${darken(
      0.2,
      globalStyles.components.button2.outlinePrimaryMixin.secondary
    )};
  }
`;

const grayTextMixin = css`
  padding: 8px 0;
  color: ${Colors.GRAY[0]};

  &:active:not(:disabled) {
    color: ${Colors.GRAY[3]};
  }
`;

const noBorderPrimaryMixin = css`
  color: ${globalStyles.components.button2.noBorderPrimaryMixin.secondary};
  padding: 6px 16px;
  ${FiraSansBold}
  text-transform: none;

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: ${globalStyles.components.button2.noBorderPrimaryMixin.primary};
  }
  &:active:not(:disabled) {
    color: ${globalStyles.components.button2.noBorderPrimaryMixin.primary};
  }
`;

const forthMixin = css`
  padding: 0.75rem 0.95rem;
  color: ${globalStyles.components.button2.forthMixin.primary};
`;

// Size mixin
const smallMixin = css`
  height: 32px;
`;

export {
  primaryMixin,
  outlinePrimaryMixin,
  grayTextMixin,
  noBorderPrimaryMixin,
  smallMixin,
  forthMixin,
};
